/*
 * File: index.ts
 * Created: 2025-12-03 08:57:15
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-05 11:36:54
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { RegisterTheme } from "@/../core/theme";

import {
    SidebarNav,
    SidebarNavDivider,
    SidebarNavTitle,
    SidebarNavItem,
} from "./components/sidebar";

import BaseTheme from "../layout";
import { QuaffBlueTheme as Theme } from "./main";

import "./scss/_theme.scss";

@RegisterTheme("quaff", "w_QuaffBlueTheme")
@Component({
    components: {
        Theme,
        SidebarNav,
        SidebarNavTitle,
        SidebarNavDivider,
        SidebarNavItem,
    },
    template: "#generic-theme-layout",
})
export class QuaffBlueTheme extends BaseTheme {}
export default QuaffBlueTheme;
